import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoadingPane, PagedList, dateUtilities } from '../../common';
import * as closedActions from './closed.actions';
import './closed.scss';

export class ClosedComponent extends Component {

  componentDidMount() {
    const { closedActions } = this.props;
    closedActions.fetchList();
  }

  componentWillUpdate(nextProps, nextState) {
    const { closedActions } = this.props;
    closedActions.fetchList();
  }

  renderMessage(message) {
    const { id, content, closedAtUtc } = message || {};

    return (
      <tr key={id}>
        <td>{dateUtilities.getUserFriendlyFormatFromJson(closedAtUtc)}</td>
        <td className='message-content'>{content}</td>
        <td></td>
      </tr>);
  }

  render() {
    const { closed, closedActions } = this.props;
    const { changePageNumber } = closedActions;
    const { pagingData, listState } = closed;
    const { itemsPerPage } = pagingData || {};
    const { isFetching, err, data } = listState || {};

    var messageList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(data) {
      messageList = data.results;
      currentPage = data.currentPage;
      totalItemsCount = data.totalResults;
    }

    const headers = (
      <tr>
        <th>CLOSED DATE</th>
        <th>MESSAGE</th>
        <th>ACTIONS</th>
      </tr>
    );

    return (
      <div id='closed-messages'>
        <LoadingPane isLoading={isFetching} err={err} loadingMessage={'Loading closed notifications...'}>
          <PagedList
            header={headers}
            items={messageList}
            emptyMessage={<p>No Closed Notifications Found</p>}
            mapItem={message => this.renderMessage(message)}
            currentPage={currentPage}
            resultsPerPage={itemsPerPage}
            totalItemsCount={totalItemsCount}
            changePageNumber={page => changePageNumber(page)}/>
        </LoadingPane>
      </div>
    );
  }
}

ClosedComponent.propTypes = {
};

const mapStateToProps = ({ closed }) => {
  return {
    closed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closedActions: bindActionCreators(closedActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClosedComponent);
